(() => {
  const closeDropdowns = (except) => document.querySelectorAll('.sx-nav-dropdown[open]').forEach(item => { if (item !== except) item.open = false; });
  document.addEventListener('toggle', event => { if (event.target.matches?.('.sx-nav-dropdown') && event.target.open) closeDropdowns(event.target); }, true);
  document.addEventListener('click', event => { if (!event.target.closest('.sx-nav-dropdown')) closeDropdowns(); });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const dropdown = event.target.closest('.sx-nav-dropdown[open]');
    if (dropdown) { dropdown.open = false; dropdown.querySelector('summary').focus(); }
    else { closeDropdowns(); const nav = document.querySelector('#siteNav'); const burger = document.querySelector('.burger'); if (nav?.classList.contains('open')) { nav.classList.remove('open'); burger?.setAttribute('aria-expanded', 'false'); burger?.focus(); } }
  });
})();
